export default {
    loading : false,
    params: {
        date : null,
        type_integration: null,
        type_information_integration: null,
        is_error:1,
    },
    paramsQuery:{
        is_customer: false,
        is_provider: false,
        is_employee: false,
        filter_customer: [],
        filter_provider: [],
        filter_employee: [],
        paginate: true,
        page: 1,
        perPage: 50,
        query: '',
        sortBy: 'id',
        sort: 'ASC',
    },
    ag_grid:{
        selectedTheme:'ag-theme-balham'
    },
    report_data:[],
    types_integration: [],
    types_information_integration: [],
}



// WEBPACK FOOTER //
// ./src/modules/report-log/state.js